"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_avatar_1 = __importStar(require("react-avatar"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
require("./Avatar.scss");
const AvatarCN = ({ disabled, hasImage, customClass, size }) => {
    return (0, classnames_template_literals_1.default)(`
    typography-h200
    ${hasImage && disabled && 'opacity-40'}
    ${size
        ? `
      rounded-full
      object-cover`
        : ''}
    ${customClass}
  `);
};
const defaultRandomColors = [
    'var(--base-600)',
    'var(--r-600)',
    'var(--y-600)',
    'var(--b-600)',
    'var(--g-600)',
    'var(--n-600)'
];
const Avatar = ({ type = 'circle', size = 40, disabled = false, statusComponent, src, name, onClick, customClass = '', tooltip = false, tooltipText, color, fgColor, value, profilePicture, position, fullName }) => {
    const [errorImage, setErrorImage] = (0, react_1.useState)(false);
    src = src || profilePicture;
    return (
    // @ts-ignore
    react_1.default.createElement(react_avatar_1.ConfigProvider, { colors: defaultRandomColors },
        react_1.default.createElement("div", { className: `avatar w-max ${position ? position : 'relative'}` },
            react_1.default.createElement(TooltipContainer_1.default, { show: tooltip, align: "left", text: tooltipText || name || fullName || '', wrap: true }, src && !errorImage ? (react_1.default.createElement(AWSImage_1.default, { className: AvatarCN({
                    disabled,
                    hasImage: !!src,
                    customClass,
                    size
                }), src: src, onClick: onClick, style: {
                    width: `${size}px`,
                    height: `${size}px`,
                    maxWidth: `${size}px`,
                    maxHeight: `${size}px`
                }, onError: () => {
                    setErrorImage(true);
                } })) : (react_1.default.createElement(react_avatar_1.default, { src: src, size: String(size), className: AvatarCN({ disabled, hasImage: !!src, customClass }), round: type == 'circle' ? true : '4px', maxInitials: 2, name: name || fullName, value: value, textSizeRatio: 2, onClick: onClick, color: disabled ? 'var(--n-600)' : color, fgColor: fgColor, 
                // @ts-ignore
                title: false }))),
            react_1.default.createElement("div", { className: "absolute bottom-0 right-0" }, statusComponent))));
};
exports.default = Avatar;
